import AchievementComponent from './achievement_component'
import React, { forwardRef } from 'react'
import './achievement.scss'

var achievements_data = [
  {
    title: 'Smart India Hackathon',
    title_sub_heading: 'National Winner | Tamil Nadu',
    imagePath: process.env.PUBLIC_URL + '/images/prize.webp',
    description:
      "Team that Sam lead, won the India's biggest and the toughest 36 hr. tech hackathon. Got awarded with a ₹1,00,000 cash prize.",
    link: 'https://drive.google.com/file/d/15_JL_ylzJXEZnKbGst-_XKyTcGglnu7T/view?usp=sharing',
    rank: 'gold',
    buttonText: 'News'
  },
  {
    title: '₹4,50,000 Grant Recipient',
    title_sub_heading: 'Yukti Challenge, AICTE | New Delhi',
    imagePath: process.env.PUBLIC_URL + '/images/aicte.webp',
    description:
      'Subsequently Sam won the highest grant amount, among 36,000+ teams consisting of SIH Winners and selected startup teams.',
    link: 'https://en.wikipedia.org/wiki/KPMG',
    rank: 'gold',
    buttonText: 'More'
  },
  {
    title: 'Kavach Hackathon',
    title_sub_heading: 'Grand Finalist | Mumbai',
    imagePath: process.env.PUBLIC_URL + '/images/kavach.webp',
    description:
      'Sam was awarded by Superintendent of Mahrashtra Police, and the Director of AICTE. Offered an internship at Mahrashtra Police Cyber Cell 🛡️',
    link: 'https://www.wikiwand.com/en/KPMG',
    rank: 'silver',
    buttonText: 'More'
  },
  {
    title: 'Interviewed by MoE',
    title_sub_heading: 'Ministry of Education | New Delhi',
    imagePath: process.env.PUBLIC_URL + '/images/MoE_Interview.webp',
    description:
      "Ministry of Education (Govt of India) exclusively interviewed Sam's team for winning the biggest hackathon of the country!",
    link: 'https://youtu.be/jZPjKlnnCqI?si=1qz0Yl6w3Uk94ndr',
    rank: 'bronze',
    buttonText: 'Interview'
  },
  {
    title: 'Best Internship of Campus',
    title_sub_heading: 'NMIMS | Indore',
    imagePath: process.env.PUBLIC_URL + '/images/xperia.webp',
    description:
      'Sam received the award for bagging the best internship of the University at a prestigious Big-Fours consulting firm in his 3rd year itself',
    link: 'https://www.linkedin.com/posts/sam-varghese2003_ecstatic-to-share-that-ive-won-the-prize-activity-7262778481845960704-4mu2?utm_source=share&utm_medium=member_desktop',
    rank: 'bronze',
    buttonText: 'More'
  },
  {
    title: "'A' Grade NCC Cadet",
    title_sub_heading: 'National Cadet Corps',
    imagePath: process.env.PUBLIC_URL + '/images/ncc.webp',
    description:
      'Sam also achieved the highest grades for his performance in the NCC Exams. Unit: 2 MP Armd Sqn, Indore of the MP and Chhattisgarh Directorate',
    link: 'https://en.wikipedia.org/wiki/National_Cadet_Corps_(India)',
    rank: 'bronze',
    buttonText: 'More'
  }
]

const Achievements = forwardRef((props, ref) => {
  return (
    <div ref={ref} className='achievement_section'>
      <h1>Highlights</h1>
      {achievements_data.map((element, index) => (
        <AchievementComponent
          imagePath={element.imagePath}
          title={element.title}
          title_sub_heading={element.title_sub_heading}
          description={element.description}
          link={element.link}
          rank={element.rank}
          buttonText={element.buttonText}
          key={`${element.title}-${index}`}
        />
      ))}
    </div>
  )
})

export default Achievements
